module.exports = __webpack_public_path__ + "static/media/portfolio1.fc5cc320.png";